var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 3C7.28364 3 8 2.32841 8 1.5C8 0.671572 7.28364 0 6.4 0C5.65448 0 5.02804 0.478039 4.8504 1.125H0.4C0.179088 1.125 0 1.29289 0 1.5C0 1.70711 0.179088 1.875 0.4 1.875H4.8504C5.02804 2.52195 5.65448 3 6.4 3ZM5.6 1.5C5.6 1.91421 5.95816 2.25 6.4 2.25C6.84184 2.25 7.2 1.91421 7.2 1.5C7.2 1.08579 6.84184 0.75 6.4 0.75C5.95816 0.75 5.6 1.08579 5.6 1.5ZM0 4.5C0 3.67159 0.716344 3 1.6 3C2.34554 3 2.97198 3.47805 3.14959 4.125H7.6C7.82092 4.125 8 4.29289 8 4.5C8 4.70711 7.82092 4.875 7.6 4.875H3.14959C2.97198 5.52195 2.34554 6 1.6 6C0.716344 6 0 5.32841 0 4.5ZM2.4 4.5C2.4 4.08577 2.04183 3.75 1.6 3.75C1.15817 3.75 0.8 4.08577 0.8 4.5C0.8 4.91423 1.15817 5.25 1.6 5.25C2.04183 5.25 2.4 4.91423 2.4 4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterImg);
export default __webpack_public_path__ + "static/media/filterImg.fb2c8ea54bf8bcaa438315a264ef9dce.svg";
export { ForwardRef as ReactComponent };